import { render, staticRenderFns } from "./DecisionAid.vue?vue&type=template&id=c7072f64&scoped=true"
import script from "./DecisionAid.vue?vue&type=script&lang=js"
export * from "./DecisionAid.vue?vue&type=script&lang=js"
import style0 from "./DecisionAid.vue?vue&type=style&index=0&id=c7072f64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7072f64",
  null
  
)

export default component.exports